module.exports = __webpack_public_path__ + "static/media/basicfloor.4a160c45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/screens/occupancy/basicfloor.svg
// module id = 174
// module chunks = 0